export function customElementIsRegistered(name) {
  return document.createElement(name).constructor !== HTMLElement;
}